export type DvrWindow = {
  start: number;
  end: number;
  current: number;
  behind: number;
  atLive: boolean;
};

export const LIVE_EDGE_TOLERANCE = 2;
export const MANIFEST_PROBE_ATTEMPTS = 20;
export const MANIFEST_PROBE_DELAY_MS = 1_500;

export function dvrWindow(
  seekable: Pick<TimeRanges, "length" | "start" | "end">,
  currentTime: number,
): DvrWindow | null {
  if (seekable.length === 0) return null;
  const start = seekable.start(0);
  const end = seekable.end(seekable.length - 1);
  const current = Math.min(end, Math.max(start, currentTime));
  const behind = Math.max(0, end - current);
  return { start, end, current, behind, atLive: behind <= LIVE_EDGE_TOLERANCE };
}

export function clock(seconds: number): string {
  const whole = Math.max(0, Math.floor(seconds));
  const hours = Math.floor(whole / 3600);
  const minutes = Math.floor((whole % 3600) / 60);
  const rest = whole % 60;
  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, "0")}:${String(rest).padStart(2, "0")}`
    : `${minutes}:${String(rest).padStart(2, "0")}`;
}

export async function waitForManifest(
  probe: () => Promise<boolean>,
  wait: (milliseconds: number) => Promise<void>,
  attempts = MANIFEST_PROBE_ATTEMPTS,
): Promise<boolean> {
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    if (await probe()) return true;
    if (attempt + 1 < attempts) await wait(MANIFEST_PROBE_DELAY_MS);
  }
  return false;
}

export function availabilityUrl(source: string): string {
  return `${source}/availability`;
}
